module.exports = __webpack_public_path__ + "media/images/no_image-7c37dca4f775c493ef02592805ac5e33.png";